import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';

import { useNavigate } from 'react-router-dom';

import { ScreenBackV2WithTitle } from '../../../Components/ScreenBackV2';
import OnboardingContainer from '../../Component/OnboardingContainer';
import { getOnboardingIndustryAction } from '../../auth/action';

import IndustryCard from '../../Component/industryCard';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const IndustrySelect = () => {
  const navigate = useNavigate();
  const [industries, setIndustries] = useState([]);

  const getIndustry = async () => {
    const { data, error, message } = await getOnboardingIndustryAction();

    if (!error) {
      setIndustries(data);
    } else return toast.error(message);
  };

  useEffect(() => {
    getIndustry();
  }, []);

  const handleIndustryClick = (industry) => {
    navigate('/SubIndustrySelect', {
      state: { industry: industry },
    });
  };

  return (
    <OnboardingContainer>
      <ScreenBackV2WithTitle title={'Select Industry'} />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          mt: '2rem',
        }}
      >
        {industries.map((industry) => (
          <IndustryCard
            industryData={industry}
            onClick={() => handleIndustryClick(industry)}
          />
        ))}
      </Box>
    </OnboardingContainer>
  );
};

export default IndustrySelect;
